const buildcustomizeBold = () => (state, silent) => {
  if (silent) {
    return false;
  }

  const token = state.src;
  let start = state.pos;

  if (token[start] !== '*') {
    return false;
  }

  let pos = start + 1;
  const max = state.posMax;

  while (pos < max && token[pos] !== '*') {
    if (token[pos] === '\n') {
      return false;
    }
    pos++;
  }

  if (pos >= max || token[pos] !== '*') {
    return false;
  }

  const tokenContent = token.slice(start + 1, pos);

  if (!tokenContent.trim()) {
    return false;
  }

  state.push('strong_open', 'strong', 1);

  const strongContentToken = state.push('text', '', 0);
  strongContentToken.content = tokenContent;

  state.push('strong_close', 'strong', -1);

  state.pos = pos + 1;
  return true;
};

export default function customizeBoldPlugin(md) {
  md.inline.ruler.before('emphasis', 'customizeBold', buildcustomizeBold(md));
}